import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signup } from '../actions/userActions'
import {Redirect, Link} from 'react-router-dom'
import axios from 'axios'

@connect((store)=>{
  return {
    auth: store.user.auth,
    signupProgress: store.user.signupProgress,
    error: store.user.signupError,
  } 
})
class Register extends Component {

  state = {
    seekingJob:false,
    hackaton: false
  }
  

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.dispatch(signup(this.email.value, this.pw.value, this.name.value, this.state.seekingJob.toString(), this.state.hackaton.toString()))
  }
  
  seekingJobHandler = (e) =>{
    this.setState({seekingJob:e.target.checked})
  }

  hackatonHandler = (e) =>{
    this.setState({hackaton:e.target.checked})
  }

  render() {

    if(this.props.auth){
      return (<Redirect to='/dashboard'/>)
    }

    if(this.props.signupProgress){
      return (
      <section className="section-form color-1">
      <div className="loader"></div>
      </section>)
    }
    
    return (
      <div>
      <section className="section-form color-1">
          <h1 className="section-title">Registration</h1>
          <h3 style={{fontWeight: '400',fontSize: '16px',color: 'rgba(255, 255, 255, 0.59)'}} 
    className="section-subtitle">Already registered? <Link to="/login"> Sign in</Link></h3>
          {this.props.error?
          <p>Error: {this.props.error.message}</p>:null
          }
          <form onSubmit={this.handleSubmit}>
            <div className="formflex">
            <input className="form-input formitem" required type="text" ref={(name) => this.name = name} placeholder="Full Name"/>
            <input className="form-input formitem" required type="email" ref={(email) => this.email = email} placeholder="Email"/>
            <input className="form-input formitem" required type="password" ref={(pw) => this.pw = pw} placeholder="Create password"/>
            <p className="formitem checkbox"><input type="checkbox" checked={this.state.seekingJob} onChange={this.seekingJobHandler} />&nbsp; I’d like to find my dream job at a startup via your newsletter&nbsp;</p>
            {/* <p className="formitem checkbox"><input type="checkbox" checked={this.state.hackaton} onChange={this.hackatonHandler}/>&nbsp;
            I’m interested in learning about the <Link to="/hackathon" target="_blank">Hackathon</Link> (July 6-8)</p><br/> */}
            
            <div className="formitem">
            <p style={{fontWeight: '400',fontSize: '12px',color: 'rgba(255, 255, 255, 0.59)'}} 
    className="section-subtitle">By clicking "Register" you agree to our&nbsp; 
        <Link to="/terms" 
    target="_blank"> Terms of Service</Link> and <a href="https://www.iubenda.com/privacy-policy/94178599/cookie-policy" target="_blank" 
    target="_blank"> Cookie policy</a>
    </p>
            <button type="submit" className="btn-register">Register</button>
            </div>
            </div>
        </form>
      </section>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Register.js